import type { EDASState } from '../types';
import {
  LOAD_DATA_SUCCESS,
  LOAD_DATA_FAIL,
  LOAD_DATA_START,
  QUERY_STATE,
  SET_DATA_QUERY,
  EndpointToRedux,
  RESET_DATA_QUERY,
  EDAS_TYPE,
} from '../constants';
import { EDASAction } from '../actions';

declare module '@tmapy/redux' {
  interface AppState {
    edas: EDASState;
  }
}

const initialState: EDASState = {
  appData: {
    query: {},
    isFiltered: false,
    data: {
      config: {
        name: '',
        city: '',
        lang: '',
        menu: [],
        footer: {
          company: '',
          email: '',
          mailto: '',
        },
        initFilter: {},
        auth: {
          login: '',
          logout: '',
        },
      },
      user: '',
      filters: {},
    },
    error: null,
    queryState: QUERY_STATE.EMPTY,
  },
  catalogData: {
    query: {},
    isFiltered: false,
    data: [],
    error: null,
    queryState: QUERY_STATE.EMPTY,
  },
  detailData: {
    query: { uuid: '' },
    isFiltered: false,
    data: {
      uuid: '',
      title: '',
      type: EDAS_TYPE.app,
      keywords: [],
      description: '',
      image: { url: '' },
      type_description: '',
      is_public: false,
      topics: [],
      update: '',
      region: '',
      system: '',
      doc_url: '',
      url: '',
      system_url: '',
      access: false,
      children: {
        title: '',
        values: [],
      },
    },
    error: null,
    queryState: QUERY_STATE.EMPTY,
  },
};

export const edas = (state: EDASState = initialState, action: EDASAction): EDASState => {
  switch (action.type) {
    case LOAD_DATA_SUCCESS: {
      const stateKey = EndpointToRedux[action.payload.endpoint];
      const endpointState = state[stateKey];
      return {
        ...state,
        [stateKey]: {
          ...endpointState,
          data: action.payload.data,
          error: null,
          queryState: QUERY_STATE.SUCCESS,
          isFiltered: action.payload.isFiltered,
        },
      };
    }
    case LOAD_DATA_FAIL: {
      const stateKey = EndpointToRedux[action.payload.endpoint];
      const endpointState = state[stateKey];
      return {
        ...state,
        [stateKey]: {
          ...endpointState,
          error: action.payload.error,
          queryState: QUERY_STATE.FAIL,
        },
      };
    }
    case LOAD_DATA_START: {
      const stateKey = EndpointToRedux[action.payload.endpoint];
      const endpointState = state[stateKey];
      return {
        ...state,
        [stateKey]: {
          ...endpointState,
          data: action.payload.wipe ? initialState[stateKey] : endpointState.data,
          error: null,
          queryState: QUERY_STATE.WAITING,
        },
      };
    }
    case RESET_DATA_QUERY: {
      const stateKey = EndpointToRedux[action.payload.endpoint];
      const endpointState = state[stateKey];
      return {
        ...state,
        [stateKey]: {
          ...endpointState,
          query: {},
        },
      };
    }
    case SET_DATA_QUERY: {
      const stateKey = EndpointToRedux[action.payload.endpoint];
      const endpointState = state[stateKey];
      return {
        ...state,
        [stateKey]: {
          ...endpointState,
          query: {
            ...endpointState.query,
            ...action.payload.query,
          },
        },
      };
    }
    default: {
      return state;
    }
  }
};
